/**
 * The email addresses this shipper has outstanding external invites for.
 *
 * Selecting an invite mints a fresh follow request rather than reusing the open
 * one - that is what grants access to the shipment being created - so the same
 * address legitimately accumulates several pending rows. They collapse to a
 * single entry here so the selector never offers, or counts, one carrier twice.
 */
export function extractPendingExternalInviteEmails(
  sentFollowRequests: FollowShipperRequestAndResponse[] | undefined,
): string[] {
  const seenEmails = new Set<string>();

  return (sentFollowRequests ?? []).flatMap(({ request }) => {
    if (
      request.type !== "SHIPPER_FOLLOW_REQUEST_EXTERNAL" ||
      !request.target_email
    ) {
      return [];
    }

    const email = request.target_email;
    const deduplicationKey = email.toLowerCase();
    if (seenEmails.has(deduplicationKey)) {
      return [];
    }

    seenEmails.add(deduplicationKey);
    return [email];
  });
}
